<template>
    <container class="bg">
        <div class="cardList">
            <RepayCard v-for="(item, index) in repayList" :value="item" class="card" :key="'repaycard' + index"/>
        </div>
    </container>
</template>

<script>
    import RepayCard from './components/repayCard1';
    import webApi from '../../request/webapi';
    export default {
        name: "repayInfo",
        components: {RepayCard},
        data: function(){
            return  {
                repayList: []
            }
        },
        async mounted(){
            let remitOpenId= this.$route.params.id;
            let data = await webApi.case.queryReceiptApplyWithDraws({remitOpenId});
            if(data.statusCode == 200){
                this.repayList = data.result.filter((d) => {
                    if(d.overdueState){
                        return d;
                    }
                })
            }
        },
    }
</script>

<style scoped>
    .cardList{
        padding: 8px;
    }
    .card{
        margin-bottom: 8px;
        padding-left: 20px;
    }
</style>